import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
    public form: FormGroup;
    public nextRole: string;
    public isClient = this.authenticationService.isClient();
    public roles = this.authenticationService.currentUserValue.roles;
    public filteredRoles = this.roles.filter(role => {
        return role !== this.authenticationService.getSessionRole();
    });
    public isPreview = this.authenticationService.isPreviewMode();
    public constructor(private authenticationService: AuthenticationService) {}

    ngOnInit() {
        this.initForm();
        this.getNextRole();
    }

    private initForm(): void {
        this.form = new FormGroup({
            role: new FormControl('')
        });
    }

    getNextRole() {
        if (this.filteredRoles.length == 1) {
            this.nextRole = this.filteredRoles[0];
        }
    }

    onNextRole() {
        if (this.roles.length == 2) {
            this.authenticationService.setSessionRole(this.nextRole);
        } else {
            this.authenticationService.setSessionRole(this.form.get('role').value);
        }
        window.location.href = window.location.pathname;
    }
}
